import { render, staticRenderFns } from "./SpendByProject.vue?vue&type=template&id=cf124054&scoped=true&"
import script from "./SpendByProject.vue?vue&type=script&lang=js&"
export * from "./SpendByProject.vue?vue&type=script&lang=js&"
import style0 from "./SpendByProject.vue?vue&type=style&index=0&id=cf124054&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf124054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf124054')) {
      api.createRecord('cf124054', component.options)
    } else {
      api.reload('cf124054', component.options)
    }
    module.hot.accept("./SpendByProject.vue?vue&type=template&id=cf124054&scoped=true&", function () {
      api.rerender('cf124054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/invoices/charts/SpendByProject.vue"
export default component.exports